import { render, staticRenderFns } from "./CurrencyTypesView.vue?vue&type=template&id=0aa66240"
import script from "./CurrencyTypesView.vue?vue&type=script&lang=js"
export * from "./CurrencyTypesView.vue?vue&type=script&lang=js"
import style0 from "./CurrencyTypesView.vue?vue&type=style&index=0&id=0aa66240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports